export type MilestoneStatus = 'past' | 'active' | 'upcoming';

export interface MilestoneRow {
  id: number;
  milestone: string;
  date: Date;
  status: MilestoneStatus;
}

export const ROW_HEIGHT_PX = 48;
export const HEADER_HEIGHT_PX = 40;
export const WEEK_HEADER_HEIGHT_PX = 20;
export const DOMAIN_PADDING_DAYS = 14;
export const MS_PER_DAY = 1000 * 60 * 60 * 24;
export const MONTH_MIN_WIDTH_PX = 80;
export const TIMELINE_MIN_WIDTH_PX = 480;
export interface WeekSegment {
  start: Date;
  end: Date;
  /** ISO 8601 week number (1–53) of the year, derived from the segment's midpoint. */
  weekNumber: number;
}

export const STATUS_STYLES: Record<MilestoneStatus, { dot: string; badge: string }> = {
  past: { dot: 'bg-green-600', badge: 'bg-green-100 text-green-700' },
  active: { dot: 'bg-blue-500', badge: 'bg-blue-100 text-blue-700' },
  upcoming: { dot: 'bg-slate-400', badge: 'bg-slate-200 text-slate-700' },
};
